import Layout from "@/views/layout/Layout";

const warehouseManRouter = {
  path: "/warehouseMan",
  component: Layout,
  name: "warehouseMan",
  meta: {
    title: "库房管理",
    icon: "warehouseMan",
    roles: ["k_kufangguanli"],  // 更新顶级权限
  },
  alwaysShow: true,
  children: [
    {
      path: "basicInfoMaintenance",
      component: () => import("@/views/hrMan/orgPlan/index"),
      meta: {
        title: "基础信息维护",
        roles: ["k_jichuxinxiweihu"],  // 更新权限
      },
      children: [
        {
          path: "projectWarehouseConfig",
          component: () => import("@/views/warehouseMan/basicInfoMaintenance/ProjectWarehouseConfig.vue"),
          name: "projectWarehouseConfig",
          meta: {
            title: "项目库房配置",
            roles: ["k_xiangmukufangpeizhi"],  // 更新权限
          }
        },
        {
          path: "pointDepartmentMaintenance",
          component: () => import("@/views/warehouseMan/basicInfoMaintenance/PointDepartmentMaintenance.vue"),
          name: "pointDepartmentMaintenance",
          meta: {
            title: "点位科室维护",
            roles: ["k_dianweikeshiweihu"],  // 更新权限
          }
        },
        {
          name: "materialArchive",
          path: "materialArchive",
          component: () => import("@/views/warehouseMan/basicInfoMaintenance/MaterialArchive.vue"),
          meta: {
            title: "物料档案",
            roles: ["k_wuliaodangan"],  // 更新权限
          }
        }
      ]
    },
    {
      path: "maintenanceMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      meta: {
        title: "物料入库",
        roles: ["k_wuliaoruku"],  // 更新权限
      },
      children: [
        {
          path: "vehicleMaintenanceSupervision",
          component: () => import("@/views/warehouseMan/maintenanceMan/vehicleMaintenanceSupervision.vue"),
          name: "inboundOrder",
          meta: {
            title: "入库单",
            roles: ["k_rukudan"],  // 更新权限
          }
        },
        {
          path: "vehicleMaintenanceMan",
          component: () => import("@/views/warehouseMan/maintenanceMan/vehicleMaintenanceMan.vue"),
          name: "inboundRecord",
          meta: {
            title: "入库记录",
            roles: ["k_rukudanjilu"],  // 更新权限
          }
        }
      ]
    },
    {
      path: "recyclingOfUsedGoods",
      component: () => import("@/views/hrMan/orgPlan/index"),
      meta: {
        title: "物资出库",
        roles: ["k_wuzichuku"],  // 更新权限
      },
      children: [
        {
          path: "recyclingOfUsedGoodsMan",
          component: () => import("@/views/warehouseMan/recyclingOfUsedGoods/recyclingOfUsedGoodsMan.vue"),
          name: "outboundOrder",
          meta: {
            title: "出库单",
            roles: ["k_chukudan"],  // 更新权限
          }
        },
        {
          path: "saleOfOldPartsAuth",
          component: () => import("@/views/warehouseMan/recyclingOfUsedGoods/saleOfOldPartsAuth.vue"),
          name: "outboundConfirm",
          meta: {
            title: "出库确认",
            roles: ["k_chukuqueren"],  // 更新权限
          }
        },
        {
          path: "saleReceiptConfirmation",
          component: () => import("@/views/warehouseMan/recyclingOfUsedGoods/saleReceiptConfirmation.vue"),
          name: "outboundRecord",
          meta: {
            title: "出库记录",
            roles: ["k_chukudanjilu"],  // 更新权限
          }
        }
      ]
    },
    {
      path: "returnManage",
      component: () => import("@/views/hrMan/orgPlan/index"),
      meta: {
        title: "物料返库",
        roles: ["k_wuliaofanku"],  // 更新权限
      },
      children: [
        {
          path: "newProductReturn",
          component: () => import("@/views/warehouseMan/returnManage/newProductReturn.vue"),
          name: "newProductReturn",
          meta: {
            title: "新品返库",
            roles: ["k_xinpinfanku"],  // 更新权限
          }
        },
        {
          path: "newProductReturnConfirm",
          component: () => import("@/views/warehouseMan/returnManage/newProductReturnConfirm.vue"),
          name: "newProductReturnConfirm",
          meta: {
            title: "新品返库确认",
            roles: ["k_xinpinfankuqueren"],  // 更新权限
          }
        },
        {
          path: "newProductReturnRecord",
          component: () => import("@/views/warehouseMan/returnManage/newProductReturnRecord.vue"),
          name: "newProductReturnRecord",
          meta: {
            title: "新品返库记录",
            roles: ["k_xinpinfankujilu"],  // 更新权限
          }
        },
        {
          path: "scrapProductReturn",
          component: () => import("@/views/warehouseMan/returnManage/scrapProductReturn.vue"),
          name: "scrapProductReturn",
          meta: {
            title: "报废品返库",
            roles: ["k_baofeipinfanku"],  // 更新权限
          }
        },
        {
          path: "scrapProductReturnProcess",
          component: () => import("@/views/warehouseMan/returnManage/scrapProductReturnProcess.vue"),
          name: "scrapProductReturnProcess",
          meta: {
            title: "报废品返库处理",
            roles: ["k_baofeipinfankuchuli"],  // 更新权限
          }
        },
        {
          path: "scrapProductReturnAudit",
          component: () => import("@/views/warehouseMan/returnManage/scrapProductReturnAudit.vue"),
          name: "scrapProductReturnAudit",
          meta: {
            title: "报废品返库审核",
            roles: ["k_baofeipinfankushenhe"],  // 更新权限
          }
        },
        {
          path: "scrapProductReturnRecord",
          component: () => import("@/views/warehouseMan/returnManage/scrapProductReturnRecord.vue"),
          name: "scrapProductReturnRecord",
          meta: {
            title: "报废品返库记录",
            roles: ["k_baofeipinfankujilu"],  // 更新权限
          }
        }
      ]
    },
    {
      path: "warehouseManage",
      component: () => import("@/views/hrMan/orgPlan/index"),
      meta: {
        title: "库存管理",
        roles: ["k_kucunguanli"],  // 更新权限
      },
      children: [
        {
          path: "materialQuery",
          component: () => import("@/views/warehouseMan/warehouseManage/materialQuery.vue"),
          name: "materialQuery",
          meta: {
            title: "库房物料查询",
            roles: ["k_kufangwuliaochaxun"],  // 更新权限
          }
        },
        {
          path: "inventoryCheck",
          component: () => import("@/views/warehouseMan/warehouseManage/inventoryCheck.vue"),
          name: "inventoryCheck",
          meta: {
            title: "库房盘点",
            roles: ["k_kufangpandian"],  // 更新权限
          }
        }
      ]
    },
     {
      path: "reportManagement",
      component: () => import("@/views/hrMan/orgPlan/index"),
      meta: {
        title: "报表管理",
        roles: ["kufangbaobiaoguanli"],  // 报表管理权限
      },
      alwaysShow: true,
      children: [
        {
          path: "reportByDepartment",
          component: () => import("@/views/warehouseMan/recyclingOfUsedGoods/reportByDepartment.vue"),
          name: "reportByDepartment",
          meta: {
            title: "科室出库物料统计",
            roles: ["keshichukuwuliaotongji"],  // 科室出库统计权限
          }
        },
        {
          path: "reportByUser",
          component: () => import("@/views/warehouseMan/recyclingOfUsedGoods/reportByUser.vue"),
          name: "reportByUser",
          meta: {
            title: "人员出库物料统计",
            roles: ["renyuanchukuwuliaotongji"],  // 人员出库统计权限
          }
        },
        {
          path: "reportByMaterial",
          component: () => import("@/views/warehouseMan/recyclingOfUsedGoods/reportByMaterial.vue"),
          name: "reportByMaterial",
          meta: {
            title: "物料出库统计",
            roles: ["wuliaochukutongji"],  // 物料出库统计权限
          }
        }
      ]
    },
  ]
};

export default warehouseManRouter;
